import { createBrowserRouter, Navigate } from "react-router-dom";

/**
 * AUTH
 */
import ProtectedRoute from "../components/auth/ProtectedRoute";

import PermissionRoute from "../components/auth/PermissionRoute.jsx";

/**
 * LAYOUTS
 */
import AuthLayout from "../layouts/AuthLayout";

import DashboardLayout from "../layouts/DashboardLayout";

/**
 * AUTH PAGES
 */
import SetupAccountPage from "../pages/auth/setup/SetupAccountPage";

import LoginPage from "../pages/auth/login/LoginPage";

/**
 * DASHBOARD PAGES
 */
import DashboardPage from "../pages/dashboard/DashboardPage";

import SchoolYearsPage from "../pages/dashboard/schoolYears/SchoolYearsPage";
import FieldPlaygroundPage from "../pages/dashboard/fieldPlayground/FieldPlaygroundPage.jsx";
import FieldConfigsPage from "../pages/dashboard/fieldConfigs/FieldConfigsPage.jsx";
import UsersPage from "../pages/dashboard/users/UsersPage.jsx";
import PageLoader from "../components/ui/pageLoader/PageLoader.jsx";
import ClientsPage from "../pages/dashboard/clients/ClientsPage.jsx";
import DossiersPage from "../pages/dashboard/dossiers/DossiersPage.jsx";
import DossierDetailsPage from "../pages/dashboard/dossiers/details/DossierDetailsPage.jsx";
import SettingsPage from "../pages/dashboard/settings/SettingsPage";
import ExcelImportPage from "../modules/excelImport/pages/ExcelImportPage";
import OrganizationsPage from "../pages/dashboard/organizations/OrganizationsPage.jsx";
import CreateOrganizationPage from "../pages/dashboard/organizations/CreateOrganizationPage.jsx";
import OrganizationDetailsPage from "../pages/dashboard/organizations/OrganizationDetailsPage.jsx";
import EditOrganizationPage from "../pages/dashboard/organizations/EditOrganizationPage.jsx";
import OrganizationCoachesPage from "../pages/dashboard/organizations/OrganizationCoachesPage.jsx";
/**
 * ROUTER
 */
export const router = createBrowserRouter([
  /**
   * ROOT
   */
  {
    path: "/",

    element: <Navigate to="/login" replace />,
  },

  /**
   * AUTH
   */
  {
    element: <AuthLayout />,

    children: [
      {
        path: "/setup-account",

        element: <SetupAccountPage />,
      },

      {
        path: "/login",

        element: <LoginPage />,
      },
    ],
  },

  /**
   * DASHBOARD
   */
  {
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),

    children: [
      /**
       * DASHBOARD HOME
       */
      {
        path: "/dashboard",

        element: <DashboardPage />,
      },

      /**
       * SCHOOL YEARS
       */
      {
        path: "/dashboard/school-years",

        element: (
          <PermissionRoute permission="schoolYear.read">
            <SchoolYearsPage />
          </PermissionRoute>
        ),
      },

      {
        path: "/dashboard/field-playground",
        element: (
          <ProtectedRoute>
            <FieldPlaygroundPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/loading",
        element: (
          <ProtectedRoute>
            <PageLoader />
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/field-configs",
        element: (
          <ProtectedRoute>
            <FieldConfigsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/users",
        element: (
          <ProtectedRoute>
            <PermissionRoute permission="user.read">
              <UsersPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/clients",
        element: (
          <ProtectedRoute>
            <PermissionRoute permission="client.read">
              <ClientsPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/dossiers",
        element: (
          <ProtectedRoute>
            <PermissionRoute permission="dossier.read">
              <DossiersPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/dossiers/:id",
        element: (
          <ProtectedRoute>
            <PermissionRoute permission="dossier.read">
              <DossierDetailsPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },

      {
        path: "/dashboard/settings",
        element: (
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/excel-import",
        element: (
          <ProtectedRoute>
            <PermissionRoute permission="excel.import">
              <ExcelImportPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/organizations",
        element: (
          <ProtectedRoute>
            <PermissionRoute permission="organization.admin">
              <OrganizationsPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/organizations/new",
        element: (
          <ProtectedRoute>
            <PermissionRoute permission="organization.admin">
              <CreateOrganizationPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/organizations/:id",
        element: (
          <ProtectedRoute>
            <PermissionRoute permission="organization.admin">
              <OrganizationDetailsPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/organizations/:id/coaches",
        element: (
          <ProtectedRoute>
            <PermissionRoute permission="organization.admin">
              <OrganizationCoachesPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/organizations/:id/edit",
        element: (
          <ProtectedRoute>
            <PermissionRoute permission="organization.admin">
              <EditOrganizationPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      /**
       * FALLBACK
       */
      {
        path: "*",

        element: <Navigate to="/dashboard" replace />,
      },
    ],
  },

  /**
   * GLOBAL FALLBACK
   */
  {
    path: "*",

    element: <Navigate to="/login" replace />,
  },
]);

export default router;
